var _line, _path, _path2, _line2, _line3, _line4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 2.5,
    x2: 12.5,
    y2: 2.5,
    stroke: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4L2.25 9.75L2.45841 14.5434C2.48167 15.0783 2.92208 15.5 3.45747 15.5H9.54253C10.0779 15.5 10.5183 15.0783 10.5416 14.5434L11 4",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 2V1.5C4.5 0.947715 4.94772 0.5 5.5 0.5H7.5C8.05228 0.5 8.5 0.947715 8.5 1.5V2",
    stroke: "currentColor"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 4.5,
    x2: 6.5,
    y2: 13,
    stroke: "currentColor"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 8.64813,
    y1: 4.53747,
    x2: 8.35149,
    y2: 13.0323,
    stroke: "currentColor"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 4.35223,
    y1: 4.5326,
    x2: 4.64888,
    y2: 13.0274,
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.8d02eec8034e46db76720b66b8f83ea2.svg";
export { ForwardRef as ReactComponent };